import React, { useMemo } from "react";
import { Paper, Box, Typography, Stack, Chip } from "@mui/material";

function getRiskReason(lead) {
    if (lead?.riskReason) return lead.riskReason;
    if (lead?.sla?.status === "BREACHED") return "SLA estourado";
    if (lead?.flags?.readyForScheduling) return "Pronto p/ agendar";
    if (lead?.stage === "DATA_COLLECTION") return "Travado na coleta";
    return "Sem resposta";
}

export default function RiskLeadsCard({ data }) {
    const list = useMemo(() => (Array.isArray(data) ? data : []), [data]);

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2.5,
                borderRadius: 3,
                border: "1px solid var(--border)",
                background: "var(--branco)",
            }}
        >
            <Box sx={{ mb: 1 }}>
                <Typography sx={{ fontWeight: 800, color: "var(--cise-blue)" }}>
                    Leads em Risco
                </Typography>
                <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }}>
                    Prioridade operacional (ação imediata)
                </Typography>
            </Box>

            {list.length === 0 ? (
                <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }}>
                    Nenhum lead em risco agora.
                </Typography>
            ) : (
                <Stack spacing={1}>
                    {list.slice(0, 6).map((lead, idx) => {
                        const name =
                            lead?.name ||
                            lead?.leadName ||
                            lead?.profile?.name ||
                            lead?.id ||
                            `Lead ${idx + 1}`;

                        const reason = getRiskReason(lead);

                        return (
                            <Box
                                key={lead?.id || idx}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                    p: 1,
                                    borderRadius: 2,
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                }}
                            >
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontWeight: 800, fontSize: 13 }} noWrap>
                                        {name}
                                    </Typography>
                                    <Typography
                                        sx={{ fontSize: 12, color: "var(--cise-text-muted)" }}
                                        noWrap
                                    >
                                        {reason}
                                    </Typography>
                                </Box>

                                <Chip
                                    label="Ação"
                                    size="small"
                                    sx={{
                                        fontWeight: 800,
                                        background: "rgba(0, 122, 255, 0.15)",
                                        color: "var(--cise-blue)",
                                        border: "1px solid rgba(0, 122, 255, 0.25)",
                                    }}
                                />
                            </Box>
                        );
                    })}

                    {list.length > 6 && (
                        <Typography sx={{ fontSize: 12, color: "var(--cise-text-muted)" }}>
                            +{list.length - 6} outros leads em risco
                        </Typography>
                    )}
                </Stack>
            )}
        </Paper>
    );
}